import { makeStyles } from 'tss-react/mui';

import { FontSize, ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles<void, 'menuList'>({
  name: 'MuiSunrunHeader',
  uniqId: '1rtBv2',
})(
  (
    { breakpoints, brandColors, type, headerHeight, typography },
    _params,
    classes
  ) => ({
    LightOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      background:
        'linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 88.39%)',
      '& a:hover': {
        color: brandColors.chargeBlue,
      },
      color: brandColors.white,
    },
    DarkOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      background:
        'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 80.36%)',
      '& a:hover': {
        color: brandColors.infoMain,
      },
      color: brandColors.black,
    },
    PrimaryBlue: {
      backgroundColor: brandColors.primaryMain,
      '& a:hover': {
        color: brandColors.chargeBlue,
      },
      color: brandColors.white,
    },
    header: {
      display: 'flex',
      height: headerHeight.height,
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '100%',
      zIndex: 1000,
      padding: `0 ${typography.pxToRem(24)}`,
      '& a': {
        ...type['16_medium'],
        cursor: 'pointer',
      },
      ...type['16_medium'],
      '& a:not(:last-child)': {
        marginRight: typography.pxToRem(32),
      },
      '& a:first-child': {
        marginRight: typography.pxToRem(69),
      },
      [breakpoints.up(ScreenSize.MEDIUM)]: {
        padding: `0 ${typography.pxToRem(36)}`,
      },
      '& .MuiGrid-container': {
        padding: '0 !important',
      },
      '& .MuiGrid-spacing-xs-3 > .MuiGrid-item': {
        paddingRight: 0,
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'baseline',
      },
      [breakpoints.up(ScreenSize.EXTRA_LARGE)]: {
        left: '0',
      },
    },
    logo: {
      margin: `${typography.pxToRem(12)} ${typography.pxToRem(5)}`,
    },
    menuIcon: {
      cursor: 'pointer',
      color: brandColors.white,
      background: 'transparent',
      border: 'none',
      padding: 0,
      '& .MuiSvgIcon-root': {
        fontSize: FontSize.PX_32,
      },
    },
    dark: {
      color: brandColors.black,
    },
    light: {
      color: brandColors.white,
    },
    phoneLink: {
      marginRight: `${typography.pxToRem(32)}!important`,
    },
    phoneIcon: {
      color: brandColors.white,
      padding: `0px ${typography.pxToRem(4)} 0px 0px`,
      marginRight: `0 !important`, // this code is throwaway so not doing a css refactor
    },
    menuItem: {
      '& .MuiPaper-root': {
        width: 150,
      },
    },
    fixed: {
      position: 'sticky',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 999,
      background: brandColors.primaryMain,
    },
    initial: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 999,
    },
    categoryContainer: {
      display: 'flex',
    },
    menuCategory: {
      marginRight: '4.3125rem',
      position: 'relative',
      [`&:hover .${classes.menuList}`]: {
        display: 'block',
      },
    },
    categoryItem: {
      display: 'flex',
      height: '50px',
      alignItems: 'center',
      '&:hover': {
        color: brandColors.chargeBlue,
      },
    },
    menuList: {
      position: 'absolute',
      top: '100%',
      left: 0,
      display: 'none',
      width: '200px',
      padding: '8px 0',
      margin: 0,
      listStyle: 'none',
      background: brandColors.white,
      boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
      borderRadius: 2,
      '& li': {
        padding: '10px 20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        fontWeight: 400,
        lineHeight: 1.5,
        paddingTop: '6px',
        whiteSpace: 'nowrap',
        paddingBottom: '6px',
        color: brandColors.black,
        '&:hover': {
          color: brandColors.black,
          textDecoration: 'none',
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '& a': {
          textDecoration: 'none',
          margin: 0,
          display: 'block',
          width: typography.pxToRem(180),
          height: '100%',
          '&:hover': {
            textDecoration: 'none',
            color: brandColors.black,
          },
        },
      },
    },
  })
);

export default useStyles;
